/**
 * Simple Storage Manager
 * Handles localStorage/sessionStorage with basic error handling
 * Maximum 100 lines - focused on core functionality
 */

class SimpleStorage {
    constructor() {
        this.isAvailable = this.checkAvailability();
    }

    /**
     * Check if storage is available
     */
    checkAvailability() {
        try {
            const test = '__storage_test__';
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            console.warn('Storage not available:', e.message);
            return false;
        }
    }

    /**
     * Set authentication token
     */
    setToken(token) {
        try {
            if (this.isAvailable && token) {
                localStorage.setItem('auth_token', token);
                return true;
            }
            return false;
        } catch (e) {
            console.error('Failed to set token:', e.message);
            return false;
        }
    }

    /**
     * Get authentication token
     */
    getToken() {
        try {
            if (this.isAvailable) {
                return localStorage.getItem('auth_token') || null;
            }
            return null;
        } catch (e) {
            console.error('Failed to get token:', e.message);
            return null;
        }
    }

    /**
     * Remove authentication token
     */
    removeToken() {
        try {
            if (this.isAvailable) {
                localStorage.removeItem('auth_token');
                return true;
            }
            return false;
        } catch (e) {
            console.error('Failed to remove token:', e.message);
            return false;
        }
    }

    /**
     * Set data with key
     */
    setData(key, data) {
        try {
            if (this.isAvailable && key) {
                const serialized = JSON.stringify(data);
                localStorage.setItem(`data_${key}`, serialized);
                return true;
            }
            return false;
        } catch (e) {
            console.error('Failed to set data:', e.message);
            return false;
        }
    }

    /**
     * Get data by key with default value
     */
    getData(key, defaultValue = null) {
        try {
            if (this.isAvailable && key) {
                const item = localStorage.getItem(`data_${key}`);
                return item ? JSON.parse(item) : defaultValue;
            }
            return defaultValue;
        } catch (e) {
            console.error('Failed to get data:', e.message);
            return defaultValue;
        }
    }

    /**
     * Check if storage is available
     */
    isStorageAvailable() {
        return this.isAvailable;
    }
}

// Export singleton instance
const simpleStorage = new SimpleStorage();
export default simpleStorage; 